import * as React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  padding: 5px 9px;
  margin: 0 10px 10px 0;
  border-bottom: none;
  font-weight: 700;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.PURPLE};
  border-radius: 4px;
  background: rgba(71, 57, 130, 0.1);
  white-space: nowrap;
  &:hover {
    background: rgba(71, 57, 130, 1);
    color: ${({ theme }) => theme.colors.WHITE};
  }
`;

interface Props {
  slug?: string;
  title?: string;
}

export const Tag: React.ComponentType<Props> = React.memo(({ title, slug }) => {
  return <StyledLink to={`/use-cases/tag/${slug}`}>{title}</StyledLink>;
});
